exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-page-search-wrapper[data-v-7c32d1b2] { margin-bottom: 15px;\n}\n.invite-block[data-v-7c32d1b2] { margin-bottom: 16px;\n}\n.invite-label[data-v-7c32d1b2] { color: #888; margin-bottom: 4px;\n}\n.invite-link[data-v-7c32d1b2] { background: #f5f5f5; padding: 6px 10px; border-radius: 4px; word-break: break-all; margin-bottom: 8px; color: #1890ff;\n}\n.invite-tip[data-v-7c32d1b2] { color: #999; font-size: 12px; margin-top: 8px;\n}\n.invite-archive-tip[data-v-7c32d1b2] { color: #999; font-size: 12px; margin-top: 4px;\n}\n", ""]);

// exports
